export const sectionHeadingCellSx = {
    p: 0,
    pb: "12px",
}

export function getContentCellSx(side, highlight) {
    return {
        p: 0,
        pt: "14px",
        verticalAlign: "top",
        ...(side === "left" ? { pr: "20px" } : { pl: "20px" }),
        ...(highlight && side === "right" ? { borderLeft: "1px solid #d7dce2" } : {}),
    }
}

export function shouldRenderPlaceholder({ task, status, side, showUnchangedNote }) {
    if (!task) return true
    if (status === "new" && side === "left") return true
    if (status === "removed" && side === "right") return true
    if (status === "unchanged" && showUnchangedNote && side === "left") return true
    return false
}
